import React from "react"
import { BsArrowRightShort } from "react-icons/bs"
import { IconContext } from "react-icons"
import styled, { css } from "styled-components"

import { media } from "../styles/media"
import { pagePath } from "../constants/link"
import { LinkButton, BackLinkButton } from "./Link"
// import { HistoryBackButton } from "./Button"

const ArrowDesign = () => (
  <IconContext.Provider value={{ color: "white", size: "1.62em" }}>
    <BsArrowRightShort />
  </IconContext.Provider>
)

const UnderItems = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-around;
  /* padding: 10px 5% 30px; */
  margin-block: 50px;
  ${() =>
    media.tablet(css`
      width: 100%;
      /* padding: 30px 0 30px; */
    `)}
  ${() =>
    media.sp(css`
      margin-inline: auto;
      width: 300px;
      flex-direction: column;
      row-gap: 1rem;
    `)}
`

const ProductLinks = () => {
  return (
    <UnderItems>
      {/* <HistoryBackButton /> */}
      <BackLinkButton to="/" text="もどる" />
      <LinkButton
        to={pagePath.productSearch.path}
        text={pagePath.productSearch.text}
        iconComponent={<ArrowDesign />}
      />
      <LinkButton
        to={pagePath.inquiry.path}
        text={pagePath.inquiry.text}
        iconComponent={<ArrowDesign />}
      />
      {/* <Link to={pagePath.thisMonthProducts.path}>
        {pagePath.thisMonthProducts.text2}
        <ArrowDesign />
      </Link> */}
      {/* <Link to={pagePath.allergenSearch.path}>
        {pagePath.allergenSearch.text}
        <ArrowDesign />
      </Link> */}
      {/* <Link to={pagePath.inquiry.path}>
        {pagePath.inquiry.text}
        <ArrowDesign />
      </Link> */}
    </UnderItems>
  )
}

export default ProductLinks
